<!-- About Hero Section -->
<section class="about-hero">
  <div class="container">
    <div class="about-hero-content">
      <h1 >About Strong Towing Services</h1>
      <p>Your trusted partner for reliable towing and roadside assistance since 2009</p>
    </div>
  </div>
</section>

<!-- Company Story -->
<section class="company-story">
  <div class="container">
    <div class="story-content">
      <div class="story-text">
        <h2>Our Story</h2>
        <p>
          Founded in 2009, Strong Towing Services has grown from a small local business to one of the most trusted 
          towing companies in the region. What started as a single truck operation has evolved into a comprehensive 
          fleet serving customers across three states.
        </p>
        <p>
          Our commitment to excellence, reliability, and customer satisfaction has earned us the trust of thousands 
          of customers and partnerships with major insurance companies and automotive clubs.
        </p>
        <div class="story-stats">
          <div class="stat-item">
            <span class="stat-number">15+</span>
            <span class="stat-label">Years of Experience</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">10,000+</span>
            <span class="stat-label">Happy Customers</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">24/7</span>
            <span class="stat-label">Service Availability</span>
          </div>
        </div>
      </div>
      <div class="story-image">
        <img src="/images/photage/photage-2.jpeg" alt="Strong Towing Services Team" />
      </div>
    </div>
  </div>
</section>

<!-- Photo Gallery Section -->
<section class="photo-gallery-section">
  <div class="container">
    <h2>Our Gallery</h2>
    <p>See our team and vehicles in action providing exceptional service</p>
    
    <div class="gallery-grid">
      <div class="gallery-item" *ngFor="let photo of photoGallery">
        <div class="gallery-image-wrapper">
          <img [src]="photo.image" [alt]="photo.alt" />
          <div class="gallery-overlay">
            <i class="fas fa-eye"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Mission & Values -->
<section class="mission-values">
  <div class="container">
    <div class="mission-content">
      <div class="mission-card">
        <div class="mission-icon">
          <i class="fas fa-bullseye"></i>
        </div>
        <h3>Our Mission</h3>
        <p>
          To provide fast, reliable, and professional towing and roadside assistance services that exceed 
          customer expectations while maintaining the highest standards of safety and integrity.
        </p>
      </div>
      
      <div class="mission-card">
        <div class="mission-icon">
          <i class="fas fa-heart"></i>
        </div>
        <h3>Our Values</h3>
        <ul>
          <li>Customer First - Every decision we make puts our customers at the center</li>
          <li>Safety Above All - We prioritize safety in everything we do</li>
          <li>Integrity - We conduct business with honesty and transparency</li>
          <li>Excellence - We strive for the highest quality in all our services</li>
          <li>Reliability - We deliver on our promises, every time</li>
        </ul>
      </div>
      
      <div class="mission-card">
        <div class="mission-icon">
          <i class="fas fa-eye"></i>
        </div>
        <h3>Our Vision</h3>
        <p>
          To be the leading towing and roadside assistance provider in the region, known for our 
          exceptional service, innovative solutions, and unwavering commitment to customer satisfaction.
        </p>
      </div>
    </div>
  </div>
</section>

<!-- Team Section -->
<section class="team-section">
  <div class="container">
    <h2>Meet Our Team</h2>
    <p>Experienced professionals dedicated to providing you with the best service</p>
    
    <div class="team-grid">
      <div class="team-member" *ngFor="let member of teamMembers">
        <div class="member-image">
          <i class="fas fa-star"></i>
        </div>
        <div class="member-info">
          <h3>{{ member.name }}</h3>
          <p class="member-position">{{ member.position }}</p>
          <p class="member-experience" *ngIf="member.experience">{{ member.experience }}</p>
          <div class="member-skills">
            <span class="skill-tag" *ngFor="let skill of member.skills">{{ skill }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Certifications & Awards -->
<section class="certifications">
  <div class="container">
    <h2>Certifications & Awards</h2>
    <p>Recognized for our commitment to excellence and safety</p>
    
    <div class="certifications-grid">
      <div class="cert-item" *ngFor="let cert of certifications">
        <div class="cert-icon">
          <i [class]="cert.icon"></i>
        </div>
        <h3>{{ cert.name }}</h3>
        <p>{{ cert.description }}</p>
        <span class="cert-year">{{ cert.year }}</span>
      </div>
    </div>
  </div>
</section>

<!-- Fleet & Equipment -->
<section class="fleet-equipment">
  <div class="container">
    <div class="fleet-content">
      <div class="fleet-text">
        <h2>Our Fleet & Equipment</h2>
        <p>
          We maintain a modern fleet of towing vehicles and state-of-the-art equipment to ensure 
          safe and efficient service delivery. Our vehicles are regularly inspected and maintained 
          to the highest standards.
        </p>
        
        <div class="fleet-features">
          <div class="feature-item" *ngFor="let feature of fleetFeatures">
            <i [class]="feature.icon"></i>
            <div>
              <h4>{{ feature.title }}</h4>
              <p>{{ feature.description }}</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="fleet-gallery">
        <div class="gallery-item" *ngFor="let vehicle of fleetVehicles">
          <img [src]="vehicle.image" [alt]="vehicle.name" />
          <div class="vehicle-info">
            <h4>{{ vehicle.name }}</h4>
            <p>{{ vehicle.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Community Involvement -->
<section class="community-involvement">
  <div class="container">
    <h2>Community Involvement</h2>
    <p>We're proud to give back to the communities we serve</p>
    
    <div class="community-grid">
      <div class="community-item" *ngFor="let initiative of communityInitiatives">
        <div class="initiative-image">
          <img [src]="initiative.image" [alt]="initiative.title" />
        </div>
        <div class="initiative-content">
          <h3>{{ initiative.title }}</h3>
          <p>{{ initiative.description }}</p>
          <span class="initiative-year">{{ initiative.year }}</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Contact CTA -->
<section class="contact-cta">
  <div class="container">
    <div class="cta-content">
      <h2>Ready to Experience the Strong Towing Difference?</h2>
      <p>Contact us today for reliable towing and roadside assistance services</p>
      <div class="cta-buttons">
        <a href="tel:+17032008836" class="btn btn-primary">
          <i class="fas fa-phone"></i>
          Call Now: +1 (703) 200-8836
        </a>
        <a routerLink="/services" class="btn btn-outline">
          <i class="fas fa-tools"></i>
          View Our Services
        </a>
      </div>
    </div>
  </div>
</section>